import type { VoidFunctionComponent } from 'react';

import { useIsTruncated } from '../../../hooks/useIsTruncated';
import Tooltip from '../Tooltip';
import type { TooltipPlacement } from '../Tooltip';

export type TruncatedTooltipProps = {
  id: string;
  text: string;
  className?: string;
  placement?: TooltipPlacement;
};

/**
 * Renders text with a tooltip that only appears when the text is truncated
 * (e.g., via CSS `text-overflow: ellipsis`).
 */
export const TruncatedTooltip: VoidFunctionComponent<TruncatedTooltipProps> = ({
  id,
  text,
  className,
  placement = 'left',
}) => {
  const [ref, isTruncated] = useIsTruncated();
  return (
    <Tooltip id={id} tooltip={text} placement={placement} showTooltip={isTruncated}>
      <span ref={ref} className={className}>{text}</span>
    </Tooltip>
  );
};
